// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"c52e737e","1023":"c52e737e","1184":"c52e737e","5406":"84c812aa","5945":"c52e737e","6115":"c52e737e","6734":"8aa89eda","7260":"361ae7d6","8326":"211bc807","8689":"c52e737e"}[chunkId] + ".chunk.css";
};